<template>
  <div>
    <v-row justify="center" style="margin-bottom: 5rem">
      <v-col class="expired-membership" lg="6" md="6" sm="10">
        <div class="top-icons">
        </div>
        <h1 id="title">{{juniorHasToRegister ? "You're no longer eligible for a junior membership" : "Your membership has expired"}}</h1>
        <p>{{juniorHasToRegister ? "Time to register for an ASCA membership!" : "It happens to the best of us. But fret not, you can renew your membership now and stay part of the ASCA family!"}}</p>

        <v-col>
          <v-btn @click="onRenewMembership">{{juniorHasToRegister ? 'REGISTER' : 'RENEW'}} MEMBERSHIP</v-btn>
        </v-col>

        <a @click="onSkip">Skip for now</a>         
      </v-col>     
    </v-row>
    <v-row>
      <v-footer app color="#FAFAFA" class="footer-container">
          <v-row>
            <v-col>
              <v-img height="2rem" contain :src="logoImage" />
              <footer-text />
            </v-col>
          </v-row>
        </v-footer>
    </v-row>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import FooterText from '@/components/common/FooterText.vue';

import { UserInfo } from "@/types/User";

const logoImage = require('@/assets/logo.svg');

export default Vue.extend({
  components: { FooterText },
  name: 'ExpiredMembership',
  data() {
    return {
      logoImage,
    };
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
    juniorHasToRegister(): boolean | null {
      return this.userInfo?.juniorHasToRegister;
    },
  },
  methods: {
    onSkip() {
      this.$navigate("/");
    },
    onRenewMembership() {
      this.$router.push(this.juniorHasToRegister ? '/registration/member' : '/renew/member');
    }
  }
});
</script>
